import './index.css';
import React from "react";
import { render } from "react-dom";
import { AppRouter } from "./AppRouter";
render(<AppRouter data-id="element-241" data-mp="1wabcavth7ajd" />, document.getElementById("root"));